module.exports = __webpack_public_path__ + "static/media/ANDROS TESSERA REFRENCE PHONOSTAGE.3f005f4a.png";